import { Instrument } from './instrument'

export type Market = { marketId: string; name: string }
export type Markets = Array<Market>
export type GetMarketResponse = { data: Markets }
export type PredefinedTable = {
  predefinedTableId: string
  name: string
  /** Mercado de la tabla. Lo devuelve el catálogo; MexDer usa 30 (Futuros) y 31 (Swaps). */
  marketId: number
  /** Tipos de mercado separados por coma, tal como llegan del catálogo. */
  marketTypeIds?: string
  tags: any
  widgetTypeId?: string
  configuration?: string
}
export type PredefinedTables = Array<PredefinedTable>
export type GetPredefinedTableResponse = { data: PredefinedTables }

export class Tags {
  id: number
  name: string
  tags: any
  isSelected: boolean
  color: string
  elements: number
  constructor(id: number, name: string, tags: any, isSelected: boolean, color: string, elements: number) {
    this.id = id
    this.name = name
    this.tags = tags
    this.isSelected = isSelected
    this.color = color
    this.elements = elements
  }
}

export type TypeTag = {
  tag: string
  color: string
  tagLength: number
}

export type PredefinedTableInstrument = { instrument: Instrument; predefinedTableId: number }

export type GetPredefinedInstrumentList = { data: PredefinedTableInstrument[] }

export type isMarketOpenType = {
  data: boolean
  metadata: {
    statuscode: number
  }
}
